<template>
  <div class="dashboard-container">
    <div class="tip">{{ title }}</div>
    <component :is="currentRole" :dash="dash" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import admin from './components/admin'
import user from './components/user'

export default {
  name: 'Dashboard',
  components: { admin, user },
  data() {
    return {
      title: '',
      dash: {},
      currentRole: 'admin'
    }
  },
  computed: {
    ...mapGetters([
      'role'
    ])
  },
  created() {
    if (!this.role.includes('admin')) {
      this.currentRole = 'user'
    }
    this.init()
  },
  methods: {
    init() {
       const _t = this
       _t.$http.post('/api/dash/').then(resp => {
         if (resp.code == 0) {
           _t.dash = resp.data.dash
           _t.title = resp.data.com
         }
       })
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  padding: 20px;
  background-color: #f0f2f5;

  .tip {
    text-align: right;
    margin: 10px;
    font-size: 14px;
    color: #5a5e66;
  }
}
</style>
